import React, { useCallback, useEffect, useRef } from 'react'
import { Switch } from 'antd'
import { useAtom } from 'jotai'
import { useEventListener } from 'usehooks-ts'
import Tip from '../../../Proposal/Common/Tip'
import Card from '../../../Common/Card'
import useCorsCheck from './hooks/useCorsCheck'
import { corsStatusAtom, useStepIndex } from './hooks/useSteps'
import styles from './Tips.css'
import _ from 'lodash'

const doc = _.get(global, 'window.document', {})

const Tips = () => {
  const [corsStatus] = useAtom(corsStatusAtom)
  const [currentStep] = useStepIndex()
  const { triggerThrottled } = useCorsCheck()
  const hasScrapedSuccess = currentStep > 1
  const documentRef = useRef(doc)

  useEffect(() => {
    triggerThrottled()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /** 與 visibility 一致：僅在分頁可見時重檢（含從網址列／擴充功能 UI 回到視窗的 focus） */
  const onPageVisibleAgain = useCallback(() => {
    if (doc.visibilityState !== 'visible') {
      return
    }
    triggerThrottled()
  }, [triggerThrottled])

  useEventListener('focus', onPageVisibleAgain)
  useEventListener('visibilitychange', onPageVisibleAgain, documentRef)

  const renderStatusText = () => {
    if (corsStatus === null) {
      return <span className={styles.statusText}>檢測中...</span>
    }
    if (corsStatus === true && hasScrapedSuccess) {
      return (
        <span className={styles.statusError}>
          已開啟並抓取完成，請記得關閉
        </span>
      )
    }
    if (corsStatus === true) {
      return <span className={styles.statusSuccess}>已開啟</span>
    }
    if (corsStatus === false) {
      return <span className={styles.statusError}>未開啟</span>
    }
    return null
  }

  return (
    <Card
      hasPadding
      hasShadow
    >
      <Tip type='info'>
        <div className={styles.tipsContainer}>
          <ul className={styles.tipsList}>
            <li>
              為了避免從外部網站抓取商品資料時發生 CORS 問題，請先安裝 Chrome 擴充功能「
              <a
                href='https://chromewebstore.google.com/detail/cors-unblock/hadoojkfknbjgoppkecpgamiajljiief'
                target='_blank'
                rel='noopener noreferrer'
              >
                CORS Unblock
              </a>
              」。
            </li>
            <li>使用「跨平台賣場複製」功能時必須開啟「CORS Unblock」，方能擷取跨站資料，幫助您快速建立提案。</li>
            <li>複製完成，請關閉「CORS Unblock」。</li>
            <li>
              <a
                href='https://img.yec.tw/zq/shp-shared/frontend/201909111712/statics/supplier/Y!購物中心SCM-跨平台賣場複製_202603.pdf'
                target='_blank'
                rel='noopener noreferrer'
              >
                使用說明。
              </a>
            </li>
          </ul>
          <span>
            目前CORS Unblock狀態
            <Switch
              readOnly
              checked={corsStatus === true}
              disabled
              size='small'
              style={corsStatus === true ? { backgroundColor: '#3EC55D' } : undefined}
            />
            {renderStatusText()}
          </span>
        </div>
      </Tip>
    </Card>
  )
}

export default Tips
